import type { FinancialPositionDTO } from "../models/financialPositionDto";
import type { FinancialPositionEntity } from "../../domain/entities/FinancialPositionEntity";

export function financialPositionDtoToEntity(dto: FinancialPositionDTO): FinancialPositionEntity {
  return {
    operationalCash: {
      title: dto.operationalCash.title,
      value: dto.operationalCash.value,
      subtext: dto.operationalCash.subtext,
      chartSvgUrl: dto.operationalCash.chartSvgUrl ?? undefined,
      monthLabels: dto.operationalCash.monthLabels ?? [],
      chart: dto.operationalCash.chart,
    },
    monthlyBurn: {
      burnThisMonth: dto.monthlyBurn.burnThisMonth,
      burnPrevMonth: dto.monthlyBurn.burnPrevMonth,
      burnAvg: dto.monthlyBurn.burnAvg,
      currencyCode: dto.monthlyBurn.currencyCode,
      chart: {
        labels: dto.monthlyBurn.chart?.labels ?? [],
        values: dto.monthlyBurn.chart?.values ?? [],
      },
    },
    runway: {
      cashInBank: dto.runway.cashInBank,
      burnThisMonth: dto.runway.burnThisMonth,
      runwayMonths: dto.runway.runwayMonths ?? null,
      runwayLastMonth: dto.runway.runwayLastMonth ?? null,
      currencyCode: dto.runway.currencyCode,
    },
  };
}
